<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Dashboard</div>
            </div>
            <div class="row">
              <div class="col-12">
                <button @click="getDashboards()" class='btn btn-success float-right mt-3 mr-3'><i class='fa fa-sync-alt'></i> Recarregar</button>
              </div>
            </div>
            <div class="card-body">
                <table class='table table-striped table-bordered table-hover'>
                  <thead>
                    <tr>
                      <th>Garagem</th>
                      <th v-for="(monthAndYear, index) in monthAndYears" :key="index">{{ monthAndYear }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(branch, index) in data" :key="index">
                      <td>
                        {{ branch.name }}
                      </td>
                      <td :class="[
                        {'percent-bg-red': branch.counts[monthAndYear].total && branch.counts[monthAndYear].percentage < 50},
                        {'percent-bg-yellow': branch.counts[monthAndYear].total && branch.counts[monthAndYear].percentage >= 50 && branch.counts[monthAndYear].percentage < 100},
                        {'percent-bg-green': branch.counts[monthAndYear].total && branch.counts[monthAndYear].percentage == 100}
                      ]" v-for="(monthAndYear, index) in monthAndYears" :key="index">
                        {{ branch.counts[monthAndYear].total ? branch.counts[monthAndYear].percentage.toFixed(2) + '%' : '' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: null,
      monthAndYears: [
        moment().subtract(5, "months").format("MM/YYYY"),
        moment().subtract(4, "months").format("MM/YYYY"),
        moment().subtract(3, "months").format("MM/YYYY"),
        moment().subtract(2, "months").format("MM/YYYY"),
        moment().subtract(1, "months").format("MM/YYYY"),
        moment().format("MM/YYYY")
      ]
    }
  },
  methods: {
    monthAndYear(minus){
      return moment().subtract(minus, "months").format("MM/YYYY");
    },
    getDashboards: function() {
      const self = this;
      const api = self.$store.state.api + "dash";
      self.$http
        .get(api)
        .then(response => {
          self.data = response.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    }
  },
  mounted() {
    this.getDashboards();
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Graph.vue